import React from 'react';
import OverviewStatsContainer from '../../overview/containers/OverviewStatsContainer';
import { useSelector } from 'react-redux';
import OverviewMapContainer from '../../overview/containers/OverviewMapContainer';
import DashboardContainer from '../../dashboard/components/DashboardContainer';
import Styles from './ContentWrapper.module.scss';
import { LeftRight } from './LeftRight';
import { TourTablePage } from './TourTablePage';
import { TourPage } from './TourPage';
import classNames from 'classnames';
import { selectActiveView, selectActiveDashboardView } from '@redux';
import { OverviewContextProvider } from '@contexts/overview-context';
import { TourDetailsContextProvider } from '@other-components/tour-details-context';
import BriefingsPage from '../../briefing/components/BriefingsPage';
import PromptAdminPage from '../../briefing/components/PromptAdminPage';
import PaketshopVisitsPage from '../../paketshop/components/PaketshopVisitsPage';

type Props = {};

const FullScreenComponents = {
  'Tour-Details': (
    <TourDetailsContextProvider>
      <TourPage />
    </TourDetailsContextProvider>
  ),
  Touren: <TourTablePage />,
  Paketshops: <PaketshopVisitsPage />,
};

const ContentWrapper: React.FC<Props> = () => {
  const viewMode = useSelector(selectActiveView);
  const activeDashboard = useSelector(selectActiveDashboardView);

  // KI-Briefings is its own full-screen view (checked first: it is neither split-view nor dashboard).
  if (viewMode === 'briefings') {
    return (
      <div className={Styles.ContentWrapper}>
        <BriefingsPage />
      </div>
    );
  }

  if (viewMode === 'promptAdmin') {
    return (
      <div className={Styles.ContentWrapper}>
        <PromptAdminPage />
      </div>
    );
  }

  const isInSplitView = viewMode !== 'dashboard';
  const isInFullscreen = viewMode === 'dashboard' && ['Tour-Details', 'Touren', 'Paketshops'].includes(activeDashboard);

  if (isInSplitView) {
    return (
      <div className={classNames(Styles.ContentWrapper, Styles.SplitView)}>
        <OverviewContextProvider>
          <LeftRight
            left={<OverviewStatsContainer />}
            right={<OverviewMapContainer />}
            onSectionToggled={() => window.dispatchEvent(new Event('resize'))}
          />
        </OverviewContextProvider>
      </div>
    );
  }

  if (isInFullscreen) {
    return (
      <div className={classNames(Styles.ContentWrapper, Styles.SplitView)}>{FullScreenComponents[activeDashboard]}</div>
    );
  }

  return (
    <div className={Styles.ContentWrapper}>
      <DashboardContainer />
    </div>
  );
};

export default ContentWrapper;
